
import Cookies from 'js-cookie';

export const setToken = tokenid => {
  // token = tokenid;
  if (process.env.VUE_ENV === 'server') {
    return;
  }
  Cookies.set('token', tokenid, {
    expires: 15
  });
};

export const getToken = () => {
  if (process.env.VUE_ENV === 'server') {
    return;
    // return token;
  }

  return Cookies.get('token');
};

const clearToken = () => {
  Cookies.remove('token');
  Cookies.remove('token', { domain: '.huishoubao.com' });
  Cookies.remove('token', { domain: 'huishoubao.com' });
};

export const getUserInfo = () => {
  if (process.env.VUE_ENV === 'server') {
    return;
  }

  try {
    const unfo = JSON.parse(window.localStorage.getItem('uinfo'));
    return unfo;
  } catch (err) {
    console.log(err);
  }
};

export const setUserInfo = (tel, name, openid, headimgurl, eid) => {
  if (process.env.VUE_ENV === 'server') {
    return;
  }

  let info = {
    name,
    openid,
    headimgurl,
    eid
  };

  if (typeof tel === 'object') {
    Object.assign(info, tel);
  } else {
    info.tel = tel;
  }

  window.localStorage.setItem('uinfo', JSON.stringify(info));
};

export const updateUserTel = tel => {
  const uInfo = getUserInfo();
  uInfo.tel = tel;
  setUserInfo(uInfo);
};

export const clearUserInfo = () => {
  if (process.env.VUE_ENV === 'server') {
    return;
  }
  clearToken();
  window.localStorage.removeItem('uinfo');
  window.localStorage.removeItem('cInfo');
  window.localStorage.removeItem('yearToken');
};



// WEBPACK FOOTER //
// ./src/helper/loginStatusManger.js